import React, { useState, useEffect } from 'react';
import ClientProvider from '../../Various/ClientProvider';
import WebsitesList from './components/WebsitesList';
import WebsiteDetails from './components/WebsiteDetails';
import { useWebsitesList } from './hooks/useWebsitesList';

export default function WorkspaceWebsiteAudits() {
    const [selectedWebsiteHash, setSelectedWebsiteHash] = useState(null);
    const [websiteDetails, setWebsiteDetails] = useState(null);
    
    const wsProvider = React.useContext(ClientProvider);
    const websocketClient = wsProvider?.ws;
    
    // Use custom hook for websites list data fetching
    const {
        websites,
        totalHits,
        currentPage,
        loading,
        funnelStatusAggregation,
        selectedFunnelStatus,
        itemsPerPage,
        handlePageChange,
        handleFunnelStatusChange,
        reloadWebsites
    } = useWebsitesList(wsProvider);

    const loadWebsiteDetails = React.useCallback((hash) => {
        if (!hash || !websocketClient) {
            return;
        }
        setWebsiteDetails(null);
        websocketClient.waitForSocketAndSend({
            action: "getWebsite",
            options: {
                url_hash: hash
            }
        }, (response) => {

            // Create an object with the same keys as response.website.lighthouse_report, all values set to null
            console.log("website details", response.website);
            setWebsiteDetails(response);
        });
    }, [websocketClient]);

    // Load website details when a website is selected
    useEffect(() => {
        if (selectedWebsiteHash) {
            loadWebsiteDetails(selectedWebsiteHash);
        } else {
            setWebsiteDetails(null);
        }
    }, [selectedWebsiteHash, loadWebsiteDetails]);


    const handleWebsiteSelect = (hash, website) => {
        setSelectedWebsiteHash(hash);
    };

    const promoteWebsite = (urlHash, newLevel) => {
        wsProvider.ws.waitForSocketAndSend({
            action: "promoteWebsite",
            options: {
                url_hash: urlHash,
                new_level: newLevel
            }
        }, (response) => {
            console.log("promoteWebsite response", response);
            // Refresh the websites list after promotion
            reloadWebsites(currentPage, selectedFunnelStatus);
            // Reload selected website details so the UI shows the new funnel status
            if (urlHash === selectedWebsiteHash) {
                loadWebsiteDetails(selectedWebsiteHash);
            }
        });
    };

    return (
        <div className="container-fluid">
            <div className="row g-0">
                <div className="col-2">
                    <div style={{ padding: '10px' }}>
                        <h5>Websites</h5>
                        {loading ? (
                            <p>Loading websites...</p>
                        ) : (
                            <WebsitesList
                                websites={websites}
                                onSelect={handleWebsiteSelect}
                                selectedWebsiteHash={selectedWebsiteHash}
                                currentPage={currentPage}
                                totalHits={totalHits}
                                itemsPerPage={itemsPerPage}
                                onPageChange={handlePageChange}
                                funnelStatusAggregation={funnelStatusAggregation}
                                selectedFunnelStatus={selectedFunnelStatus}
                                onFunnelStatusChange={handleFunnelStatusChange}
                            />
                        )}
                    </div>
                </div>
                <div className="col-10">
                    <div className="row">
                        <div className="col-12 workspaceTop">
                            <div style={{ 
                                padding: '20px',
                                maxHeight: 'calc(100vh - 200px)',
                                overflow: 'auto',
                            }}>
                                {websiteDetails ? (
                                    <WebsiteDetails 
                                        websiteDetails={websiteDetails} 
                                        websiteScreenshot={websiteDetails?.website?.screenshot}
                                        websiteMobileScreenshot={websiteDetails?.website?.mobile_screenshot}
                                        selectedWebsiteHash={selectedWebsiteHash}
                                        onPromoteWebsite={promoteWebsite}
                                        onReloadWebsite={loadWebsiteDetails}
                                    />
                                ) : selectedWebsiteHash ? (
                                    <p>Loading website details...</p>
                                ) : (
                                    <p>Select a website to view details</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
